<a class="mosaico-item template-thumb"
  [attr.href]="link">

  <div class="ribbon"
    *ngIf="isNew && !comingsoon">
    <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/ico-ribbon-novo.png" alt="Projeto novo" />
  </div>

  <div
    class="bg-container"
    [ngClass]="{ 'blur-effect': !comingsoon }"
    [ngStyle]="{ 'background-image': 'url(' + cover + ')' }"
  ></div>

  <div class="wrapper">
    <div class="top"
      *ngIf="!comingsoon">
      <div class="left"></div>

      <div class="right"></div>
    </div>

    <div class="comming-soon"
      *ngIf="comingsoon">
      Em Breve
    </div>

    <div class="content"
      *ngIf="!comingsoon">
      <div class="title">{{ title }}</div>

      <div class="instrutor" *ngIf="!comingsoon && instructorname">
        <img [src]="instructorpicture" alt="{{ instructorname }}" />
        <div class="name">
          <span *ngIf="instructorname != 'UNHIDE School'">Instrutor:</span>
          {{ instructorname }}
        </div>
      </div>
    </div>

    <div class="watch-now" *ngIf="!comingsoon">
      <div class="label-watch-now-project icon-only">
        <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/icon-watch-now-2020.png" [alt]="title" />

        <div class="text">Assistir aula</div>
      </div>
    </div>
  </div>
</a>

